import { render, staticRenderFns } from "./VAuthorized.vue?vue&type=template&id=484e2dac&"
import script from "./VAuthorized.vue?vue&type=script&lang=ts&"
export * from "./VAuthorized.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports